/* step.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./step.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef, Fragment } from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import { cx } from '@atlaskit/css';
import __noop from '@atlaskit/ds-lib/noop';
import { Anchor, Pressable } from '@atlaskit/primitives/compiled';
var analyticsAttributes = {
  componentName: 'breadcrumbsItem',
  packageName: "@atlaskit/breadcrumbs",
  packageVersion: "15.3.10"
};
var noop = __noop;
var styles = {
  root: "_11c82smr _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrze3t _bfhksm61 _syaz131l _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj131l _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3131l _9h8h1fxt",
  withoutTruncation: "_1ul9idpf _1o9zkb7n",
  text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
};

/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */
var Step = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var analyticsContext = _ref.analyticsContext,
    href = _ref.href,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    _ref$onClick = _ref.onClick,
    onClickProvided = _ref$onClick === void 0 ? noop : _ref$onClick,
    target = _ref.target,
    testId = _ref.testId,
    children = _ref.children,
    truncationWidth = _ref.truncationWidth;
  var handleClick = usePlatformLeafEventHandler(_objectSpread({
    fn: onClickProvided,
    action: 'clicked',
    analyticsData: analyticsContext
  }, analyticsAttributes));
  var content = /*#__PURE__*/React.createElement(Fragment, null, iconBefore, /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: ax([styles.text])
  }, children), iconAfter);
  if (href) {
    return /*#__PURE__*/React.createElement(Anchor, {
      href: href,
      onClick: handleClick,
      target: target,
      testId: testId,
      xcss: cx(styles.root, !truncationWidth && styles.withoutTruncation),
      style: {
        maxWidth: truncationWidth
      }
    }, content);
  }
  return /*#__PURE__*/React.createElement(Pressable, {
    onClick: handleClick,
    testId: testId,
    xcss: cx(styles.root, !truncationWidth && styles.withoutTruncation),
    style: {
      maxWidth: truncationWidth
    }
  }, content);
});
export default Step;